import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Input } from "../ui/input";
import { aiApi } from "./aiApi";

const DEFAULT_MODELS = ["byta-image-1-5", "byta-image-1-5-pro", "byta-image-1-6-pro", "byta-image-1-5-turbo"];

export default function AIBytaImageSettings({ img, setImg, bytaKey, setBytaKey, llmKeyMasked }) {
  const [models, setModels] = useState([]);
  const [busy, setBusy] = useState(false);
  const loadModels = async () => {
    setBusy(true);
    try {
      const d = await aiApi.bytaModels(bytaKey);
      setModels(d.models || []);
      toast.success(`${d.models?.length || 0} model gambar Byta dimuat`);
    } catch (e) { toast.error(e.response?.data?.detail || "Gagal memuat model Byta"); } finally { setBusy(false); }
  };
  const list = Array.from(new Set([...(models.length ? models : DEFAULT_MODELS), img.byta_model].filter(Boolean)));
  return (
    <div className="grid gap-1.5 rounded-xl border border-sky-100 bg-sky-50/50 p-2" data-testid="ai-image-byta-box">
      <Input value={img.byta_base || ""} onChange={(e) => setImg({ byta_base: e.target.value })} placeholder="https://coding.byta-ai.com/v1" className="h-9 text-xs bg-white" data-testid="ai-image-byta-base" />
      <div className="flex items-center gap-1.5">
        <Input type="password" value={bytaKey} onChange={(e) => setBytaKey(e.target.value)} placeholder={img.byta_key_masked || "Kunci API Byta AI (pilihan)"} className="h-9 text-xs bg-white" data-testid="ai-image-byta-key" />
        {img.byta_key_masked && <button type="button" onClick={() => setImg({ clear_byta_key: true, byta_key_masked: "" })} className="text-[10.5px] text-rose-500 font-semibold whitespace-nowrap" data-testid="ai-image-byta-clear">Padam kunci</button>}
      </div>
      <div className="text-[10.5px] text-slate-500" data-testid="ai-image-byta-key-hint">
        {img.byta_key_masked ? "Menggunakan kunci yang ditampal di sini." : llmKeyMasked ? `Kosong = guna kunci Byta dari Tetapan Model AI (${llmKeyMasked}).` : "Tiada kunci Byta - tampal di sini atau di Tetapan Model AI > Byta AI."}
      </div>
      <div className="flex items-center gap-1.5">
        <select value={img.byta_model || ""} onChange={(e) => setImg({ byta_model: e.target.value })} className="h-9 flex-1 rounded-md border border-slate-200 bg-white px-2 text-xs" data-testid="ai-image-byta-model-select">
          {list.map((m) => <option key={m} value={m} label={m} />)}
        </select>
        <button type="button" onClick={loadModels} disabled={busy} className="h-9 px-3 rounded-full text-xs font-semibold border border-slate-200 bg-white text-slate-700 disabled:opacity-50 flex items-center gap-1" data-testid="ai-image-byta-load-models">
          {busy && <Loader2 className="h-3.5 w-3.5 animate-spin" />}Muat model
        </button>
      </div>
      <label className="flex items-center gap-1.5 text-[11px] text-slate-600"><input type="checkbox" checked={img.byta_fallback !== false} onChange={(e) => setImg({ byta_fallback: e.target.checked })} data-testid="ai-image-byta-fallback" /> Jika Byta gagal, jana dengan Emergent LLM Key (Gemini) secara automatik</label>
      <div className="text-[10.5px] text-slate-400">1-5: lalai (~30s) · 1-5-pro: resolusi tinggi · 1-6-pro: premium (~150s) · 1-5-turbo: paling pantas (tiada gambar rujukan).</div>
    </div>
  );
}
